module.exports = __webpack_public_path__ + "img/kabel_1.278e866f.webp";